
import React from 'react';
import { Member, MemberRole } from '../types/memberTypes';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem
} from '@/components/ui/select';
import MemberPermissionsCell from '../MemberPermissionsCell';

interface MemberMobileEditModeProps {
  member: Member;
  isCurrentMemberPrimaryOwner: boolean;
  getCheckedPermissionsCount: (permissions?: any[]) => number;
  handleCancelEdit: () => void;
  handleSaveEdit: () => void;
  handleRoleChange: (memberId: string, value: MemberRole) => void;
  handlePermissionChange: (memberId: string, permissionId: string, checked: boolean) => void;
}

const MemberMobileEditMode: React.FC<MemberMobileEditModeProps> = ({
  member,
  isCurrentMemberPrimaryOwner,
  getCheckedPermissionsCount,
  handleCancelEdit,
  handleSaveEdit,
  handleRoleChange,
  handlePermissionChange
}) => {
  return (
    <div className="space-y-4">
      <div>
        <p className="text-sm font-medium mb-2">Role</p>
        <Select 
          value={member.role} 
          onValueChange={(value) => handleRoleChange(member.id, value as MemberRole)}
        >
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select role" />
          </SelectTrigger>
          <SelectContent>
            {isCurrentMemberPrimaryOwner && <SelectItem value="Primary Owner">Primary Owner</SelectItem>}
            <SelectItem value="Owner">Owner</SelectItem>
            <SelectItem value="Manager">Manager</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div>
        <p className="text-sm font-medium mb-2">Permissions</p>
        <MemberPermissionsCell 
          member={member}
          handlePermissionChange={handlePermissionChange}
        />
      </div>
    </div>
  );
};

export default MemberMobileEditMode;
